// Lo que ve y hace un paciente con sesión iniciada.
export const VISTAS_DE_TURNOS = ['proximos', 'historial'];
export const TIPOS_DE_AVISO = ['recordatorio', 'confirmacion', 'resena', 'cancelacion', 'seguimiento'];
export const TIPOS_DE_RECLAMO = ['atencion', 'cobro', 'plataforma', 'otro'];
